<script setup>
import { getCurrentInstance, ref } from 'vue';
import SimpleBanner from '@/components/overview/SimpleBanner.vue';
import SimpleNewsList from '@/components/overview/SimpleNewsList.vue';
import BannerCarousel from '@/components/overview/BannerCarousel.vue';
import Card from 'primevue/card';

const { proxy } = getCurrentInstance();
const $t = proxy.$t;

const props = defineProps({
    banner: {
        type: [Object, Array],
        default: null
    },
    news: {
        type: Array,
        default: () => []
    }
});

// Check if we have multiple banners
const banners = Array.isArray(props.banner) ? props.banner : (props.banner ? [props.banner] : []);
const hasMultipleBanners = banners.length > 1;
</script>

<template>
    <div class="overview-section">
        <!-- Hero Banner Carousel (for multiple banners) -->
        <BannerCarousel v-if="hasMultipleBanners" :banners="banners" />

        <!-- Single Banner (legacy support) -->
        <SimpleBanner v-else-if="banners.length === 1" :banner="banners[0]" />

        <!-- News Section -->
        <Card v-if="news && news.length > 0" class="news-section mb-4">
            <template #title>
                <div class="flex align-items-center gap-2">
                    <i class="pi pi-megaphone text-xl"></i>
                    <span>{{ $t('Latest News & Updates') }}</span>
                </div>
            </template>

            <template #content>
                <SimpleNewsList :items="news" :loading="false" :error="null" />
            </template>
        </Card>
    </div>
</template>

<style scoped>
.overview-section {
    padding: 0 1.5rem;
}

.news-section {
    animation: slideUp 0.5s ease-out;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
</style>
